module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_instagram-924b7701b395cba13ad7bc85a6f6fab0.svg";